import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import ExpandedComment from './ExpandedComment';
import RepliesPreview from './RepliesPreview';
import SimpleComment from './SimpleComment';

class Comment extends React.Component {
    toggle = () => {
        this.props.comment.toggleExpand && this.props.comment.toggleExpand();
    }

    clickToggle = () => {
        this.toggle();
    };

    componentDidUpdate (prevProps, prevState) {
        this.expanded && !this.props.commentsStore && this.expanded.focus();

        if (this.props.expanded !== prevProps.expanded && this.props.expanded !== prevProps.comment.expanded) {
            this.toggle();
        }
    };

    renderSimpleComment = () =>
        this.props.comment.replies.length === 0
            ? (<SimpleComment comment={this.props.comment}>
                <div className='reply-text'>
                    {
                        this.props.commentsStore.resource.exists
                            ? this.props.commentsStore.canComment
                                ? gettext('Reply...')
                                : gettext('Please sign in to post replies.')
                            : gettext('Restore the resource to be able to post replies.')
                    }
                </div>
            </SimpleComment>)
            : (<SimpleComment comment={this.props.comment}/>)

    render () {
        const comment = this.props.comment;

        return (<div
            className={`comment-wrapper ${comment.resolved && comment.expanded ? 'comment-resolved' : ''}`}
            onClick={this.toggle}
            data-what='comment'
        >
            {
                comment.expanded
                    ? <ExpandedComment
                        comment={this.props.comment}
                        commentsStore={this.props.commentsStore}
                        wrapper={this}
                        ref={expanded => { this.expanded = expanded; }}
                    />
                    : this.renderSimpleComment()
            }

            {
                (!comment.expanded && comment.replies.length > 0) &&
                    <RepliesPreview
                        comment={this.props.comment}
                        commentsStore={this.props.commentsStore}
                    />
            }

        </div>);
    }
}

export default observer(Comment);

Comment.propTypes = {
    comment: PropTypes.object,
    expanded: PropTypes.bool,
    commentsStore: PropTypes.object.isRequired
};
